/**
 * =============================================================================
 * IDS CRM Web - Shared ConfirmDialog + useConfirm (Batch E UX system)
 * =============================================================================
 *
 * Replaces window.confirm across the app. Usage:
 *
 *   const { confirmElement, requestConfirm } = useConfirm();
 *   ...
 *   requestConfirm({
 *     message: 'Delete this thing?',
 *     confirmLabel: 'Delete',
 *     danger: true,
 *     onConfirm: () => doDelete()
 *   });
 *   ...
 *   return (<div>... {confirmElement}</div>);
 *
 * =============================================================================
 */

import React, { useState, useCallback } from 'react';
import './ConfirmDialog.css';

export function ConfirmDialog({ title, message, confirmLabel = 'Confirm', cancelLabel = 'Cancel', danger = false, onConfirm, onCancel }) {
  return (
    <div className="modal-overlay confirm-overlay" onClick={onCancel}>
      <div className="modal-content confirm-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="confirm-body">
          {title && <h3>{title}</h3>}
          <p>{message}</p>
        </div>
        <div className="confirm-actions">
          <button type="button" className="confirm-cancel" onClick={onCancel}>{cancelLabel}</button>
          <button
            type="button"
            className={danger ? 'confirm-danger' : 'confirm-primary'}
            onClick={onConfirm}
            autoFocus
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}

export function useConfirm() {
  const [pending, setPending] = useState(null);

  const requestConfirm = useCallback((options) => {
    setPending(options);
  }, []);

  const confirmElement = pending ? (
    <ConfirmDialog
      title={pending.title}
      message={pending.message}
      confirmLabel={pending.confirmLabel}
      cancelLabel={pending.cancelLabel}
      danger={pending.danger}
      onConfirm={() => {
        setPending(null);
        pending.onConfirm?.();
      }}
      onCancel={() => {
        setPending(null);
        pending.onCancel?.();
      }}
    />
  ) : null;

  return { confirmElement, requestConfirm };
}

export default ConfirmDialog;
